class wisepopsElement extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.load()
  }

  setupListeners () {
    super.setupListeners()
    this.listeners.add(document, 'panelClosed', this.onPanelClose.bind(this))
    this.listeners.add(document, 'panelOpened', this.onPanelOpen.bind(this))
    this.listeners.add(document, 'drawerOpen', this.onPanelOpen.bind(this))
    this.listeners.add(document, 'drawerClosed', this.onPanelClose.bind(this))
  }

  load () {
    const button = this.els?.trigger?.element
    if (!button) {
      return
    }

    const observer = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (
          mutation.attributeName === 'class' &&
          mutation.target.classList.contains('wisp_ready')
        ) {
          // Bell is ready — show the banner item
          this.externalEls.item.element.classList.remove(
            'hd-Banner_Item-hidden',
          )
          observer.disconnect()
        }
      })
    })

    observer.observe(button, { attributes: true })
  }

  // V2 detection: V2 uses #wisepops-feed with Shadow DOM, V1 uses #wisp_container
  get isV2 () {
    return (
      !document.querySelector('#wisp_container') &&
      !!document.querySelector('#wisepops-feed')
    )
  }

  // Returns the bell element (works in both V1 and V2)
  get bell () {
    return document.querySelector('.wisp_ready')
  }

  onPanelOpen (event) {
    if (event.detail.key !== 'notifications') return

    if (this.isV2) {
      // V2: click the bell to open, but only if not already open
      const bell = this.bell
      if (bell && bell.getAttribute('aria-expanded') !== 'true') {
        bell.click()
      }
    } else {
      // V1: toggle classes on the container
      this.wispContainer.classList.add(
        'wisp_container--open',
        'wisp_container-forceOpen',
      )
    }
  }

  onPanelClose (event) {
    if (event.detail.key !== 'notifications') return

    if (this.isV2) {
      // V2: click the bell to close, but only if currently open
      const bell = this.bell
      if (bell && bell.getAttribute('aria-expanded') === 'true') {
        bell.click()
      }
    } else {
      // V1: remove classes from the container
      this.wispContainer.classList.remove(
        'wisp_container--open',
        'wisp_container-forceOpen',
      )
    }
  }

  // V1: #wisp_container, V2: #wisepops-feed (for any direct references)
  get wispContainer () {
    return (
      document.querySelector('#wisp_container') ||
      document.querySelector('#wisepops-feed')
    )
  }
}

if (!customElements.get('wisepops-element')) {
  customElements.define('wisepops-element', wisepopsElement)
}
